exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".active{opacity:.5}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/module/special-components/Modal-templates/LateTimeExtension-modal.vue"],"names":[],"mappings":"AACA,QACE,UAAa,CACd","file":"LateTimeExtension-modal.vue","sourcesContent":["\n.active {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);

// exports
